<template>
  <div class="w-full bg-white ml-1 my-2 height-100 border-round">
    <div class="flex justify-center py-20 items-center mt-20">
      <div>
        <div class="flex justify-center">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
            class="w-100px"
          />
        </div>
        <div class="text-center mt-4">
          <h4 class="font-semibold text-4d4d4d text-3xl">
            Your order has been confirmed!!!
          </h4>
          <p class="fsize14 col-4f">
            The setup will take 8-10 days. Meanwhile your patience is
            appreciated.
          </p>
        </div>
        <div class="flex gap-4 mt-6 justify-center items-center">
          <vs-button
            class="bgraw border-0 text-white font-semibold fsize12 py-4 px-10 sm-fsize14"
            @click="handleClick('extentions')"
          >
            Go Back
          </vs-button>
          <!-- <vs-button
            class="bgraw border-0 text-white font-semibold fsize12 py-4 px-8 sm-fsize14"
          >
            Schedule a call
          </vs-button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import VueEllipseProgress from "vue-ellipse-progress";

export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
